export default __webpack_public_path__ + "static/media/location-black.995995d4.png";